/** 深拷贝 */
export function objDeepCopy(source) {
    if (typeof source === 'object') {
        var sourceCopy = source instanceof Array ? [] : {}
        for (var item in source) {
            if (!source[item]) {
                sourceCopy[item] = source[item]
            } else {
                sourceCopy[item] = typeof source[item] === 'object' ? objDeepCopy(source[item]) : source[item]
            }
        }
        return sourceCopy
    }
    return source
}


// WEBPACK FOOTER //
// ./src/utils/index.js